import {GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType} from "../../core/components/toolBar";
import {Config} from "../../core/config/config";
import {Grid} from "../../core/components/grid";
import {HTTPService, JsonResultClass} from "../../core/util/httpManager";
import {Helper} from "../../core/util/helper";
import {Dialog, DialogProps} from "../../core/components/dialog";
import {FieldInstance} from "../../core/components/field";
import {TextBox} from "../../core/components/textBox";
import {ComponentHelper} from "../../core/util/componentHelper";
import {DialogHelper} from "../../core/util/dialogHelper";
import {NotificationHelper} from "../../core/util/notificationHelper";
import {CheckBox} from "../../core/components/checkBox"
import {DatePicker} from "../../core/components/datePicker"
import {IsNumericTextBox} from "../../core/components/isNumericTextBox";
import { ContextGeneralSettingsApp } from "../generalSettings";
import React from "react";
export default class EditVATRate extends React.Component<EditVATRateProps, EditVATRateState> {
    private _factory = ComponentHelper.createFactory();
    private _gridOptions: any;
    private _translations: string[] = null;
    private _extend: boolean;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (this._isCurrentEntityFilled()) {
                        if (this._isCurrentEntityOk()) {
                            this._saveVATRate();
                        } else {
                            DialogHelper.alert(this._translations["Standard.DateRatio"]);
                        }

                    } else {
                        DialogHelper.alert(this._translations["Standard.PflichtfeldAllgemein"]);
                    }
                    return false;
                },
                primary: true
            }
        ],
        afterClose: () => {
            this._closeDialog();
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this._extend = false;
        this.state = { gridData: [], dialogOpen: false, selectedItem: null, dialogItem: null, onlyCurrent: true };
    }

    private _isCurrentEntityFilled = () => {
        return (!Helper.isNullOrEmpty(this.state.dialogItem.Name) && Helper.hasValue(this.state.dialogItem.From) && Helper.hasValue(this.state.dialogItem.To));
    }

    private _isCurrentEntityOk = () => {
        return (Helper.dates.toDate(this.state.dialogItem.From) < Helper.dates.toDate(this.state.dialogItem.To))
    }

    private _createDialog = () => {
        return (
            <div>
                <Dialog {...this._dialogProps} open={true}>
                    {this._createTextbox()}
                    {this._createDatePicker("From")}
                    {this._createDatePicker("To")}
                    {this._createNumericTextBox()}
                    {this._createDescriptionTextbox()}
                </Dialog>
            </div>
        );
    }

    private _createTextbox = () => {
        let props = this._factory.getDefaultTextBoxProps();
        props.value = this.state.dialogItem.Name;
        props.disabled = !this.state.dialogItem.IsNew;
        if (this._extend)
            props.disabled = true;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let dialogItem = this.state.dialogItem;
            dialogItem.Name = value;
            this.setState({ dialogItem: dialogItem });
        }

        return (
            <FieldInstance label={this._translations["Standard.Name"] + "*"} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private _createDatePicker = (value: "From" | "To") => {
        let label: string = "";
        let props = this._factory.getDefaultDatePickerProps();
        props.disabled = false;
        switch (value) {
            case "From":
                if (this._extend)
                    props.disabled = true;
                label = this._translations["Standard.Von"];
                props.value = this.state.dialogItem.From;
                props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                    let dialogItem = this.state.dialogItem;
                    dialogItem.From = value;
                    this.setState({ dialogItem: dialogItem });
                }
                break;
            case "To":
                label = this._translations["Standard.Bis"];
                props.value = this.state.dialogItem.To;
                props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                    let dialogItem = this.state.dialogItem;
                    dialogItem.To = value;
                    this.setState({ dialogItem: dialogItem });
                }
                break;
        }
        return (
            <FieldInstance label={label + "*"} noHover={true}>
                <DatePicker {...props} />
            </FieldInstance>
        );
    }

    private _createNumericTextBox = () => {
        let props = this._factory.getDefaultNumericTextBoxProps();
        props.value = this.state.dialogItem.PercentageRate;
        props.field.format = "0.00";
        props.field.decimals = 2;
        props.onChange = (field: { model: string }, value: number, dataItem?: any) => {
            if (value >= 0) {
                let dialogItem = this.state.dialogItem;
                dialogItem.PercentageRate = value;
                this.setState({ dialogItem: dialogItem });
            }
        }

        return (
            <FieldInstance label={"MSatz"} noHover={true}>
                <IsNumericTextBox {...props} />
            </FieldInstance>
        );
    }

    private _createDescriptionTextbox = () => {
        let props = this._factory.getDefaultTextBoxProps();
        props.value = Helper.getValueOrDefault(this.state.dialogItem.Description, "");
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let dialogItem = this.state.dialogItem;
            dialogItem.Description = value;
            this.setState({ dialogItem: dialogItem });
        }
        props.field.multiLine = true;

        return (
            <FieldInstance label={"Beschreibung"} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private _saveVATRate = () => {
        let url = "AddressSettings/SaveVatRates";
        HTTPService.post<JsonResultClass>(url, { model: this.state.dialogItem }).then(result => {
            if (result.Code == 0) {
                this._extend = false;
                this._getGridData();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }

    private _getGridData = (onlyCurrent: boolean = this.state.onlyCurrent) => {
        let url = "AddressSettings/GetVatRates?OnlyCurrent=" + onlyCurrent;
        HTTPService.get<JsonResultClass>(url)
            .then(result => {
                if (result.Code == 0) {
                    this.setState({ gridData: result.Data, onlyCurrent: onlyCurrent, dialogOpen: false });
                }
            });
    }

    private _deleteVATRate = () => {
        DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                HTTPService.post<JsonResultClass>("AddressSettings/DeleteVatRates", { model: this.state.selectedItem }).then(result => {
                    if (result.Code == 0) {
                        this._getGridData();
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
            }
        });
    }

    private _openDialog = (dataItem: VATRate = null) => {
        let dialogItem: VATRate;
        if (Helper.hasValue(dataItem)) {
            dialogItem = dataItem;
        } else {
            dialogItem = {
                Description: "",
                From: null,
                Name: "",
                PercentageRate: 0,
                To: null,
                IsNew: true
            }
        }
        this.setState({ dialogOpen: true, dialogItem: {...dialogItem} });
    }

    private _closeDialog = () => {
        this.setState({ dialogOpen: false });
    }

    private _createCheckBox = () => {
        if (Helper.hasValue(this._translations)) {
            let props = this._factory.getDefaultCheckBoxProps()
            props.value = this.state.onlyCurrent;
            props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                this._getGridData(value);
            }
            return (
                <>
                    <FieldInstance label={this._translations["WebSMS.GeneralSettings.Address.VATRate.OnlyCurrent"]} noHover={true}>
                        <CheckBox {...props} />
                    </FieldInstance>
                </>
            );
        } else {
            return (<></>);
        }
    }

    private _createGrid = () => {
        let fullLoaded: boolean = Helper.hasValue(this.state.gridData) && Helper.hasValue(this._gridOptions) && Helper.hasValue(this._translations);
        if (fullLoaded) {

            const itemSelected = Helper.hasValue(this.state.selectedItem);
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: itemSelected });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: itemSelected });
            const customButtons: Array<GridCustomToolBarButton> = [];
            //customButtons.push({ autoEnabledOnRecordSelected: true, caption: this._translations["WebSMS.GeneralSettings.Address.VATRate.Expend"], iconClass: "k-i-calendar-date", id: "expend", enabled: itemSelected });
            let grid = (
                <Grid data={this.state.gridData}
                    options={this._gridOptions}
                    id="vatRateGrid"
                    onSelectionChanged={this._onSelectedChange}
                    standardButtons={standardButtons}
                    onClickStandardButton={this._handleClickStandardButton}
                    customButtons={customButtons}
                    onClickCustomButton={this._handleClickCustomButton}
                />
            );
            return (
                <div style={{ height: "300px" }}>
                    {grid}
                </div>
            )
        } else {
            return (<></>);
        }
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: VATRate) => {
        this._extend = false;
        if (type == ToolBarStandardButtonType.EDIT) {
            this._openDialog(dataItem);
        } else if (type == ToolBarStandardButtonType.NEW) {
            this._openDialog();
        } else if (type == ToolBarStandardButtonType.DELETE) {
            this._deleteVATRate();
        }
    }

    private _onSelectedChange = (dataItem: any) => {
        this._extend = false;
        this.setState({ selectedItem: { ...dataItem } });
    }

    private _handleClickCustomButton = (id: string, dataItem: VATRate) => {
        switch (id) {
            case ("expend"):
                const item = { ...dataItem };
                let to = item.To;
                if (!Helper.hasValue(to)) {
                    to = this.state.gridData.find(f => f.Name === item.Name).To;
                }
                const d = new Date(to);
                item.From = new Date(d.getTime() + 86400000);
                item.To = null;
                item.IsNew = true;
                this._extend = true;
                this._openDialog(item);
                break;
        }
    }

    componentDidMount() {
        this._gridOptions = this.props.context.vATRateGridOptions
        this._translations = this.props.context.translations;
        this._getGridData();
    }

    render() {
        const checkBox = this._createCheckBox()
        const grid = this._createGrid();
        const dialog = this.state.dialogOpen ? this._createDialog() : <></>;
        return (
            <>
                {checkBox}
                {grid}
                {dialog}
            </>);
    }
};

interface EditVATRateProps {
    context: ContextGeneralSettingsApp;
}

interface EditVATRateState {
    dialogOpen: boolean;
    onlyCurrent: boolean;
    selectedItem: VATRate;
    dialogItem: VATRate;
    gridData: VATRate[];
}

interface VATRate {
    Name: string;
    From: Date;
    To: Date;
    PercentageRate: number;
    Description: string;
    IsNew: boolean;
}